﻿import * as Model from '../../models/models';

export class RatingFactorsViewModel {
    public submission: Model.ISubmission;
    public primaryContact: Model.IUserProfile;
    public phone: Model.IPhone;
    public policyholder: Model.IPolicyholder;
    public submissionStatuses: Model.ICode[];

    public billingReferenceNumberEditable: boolean;
    public autoPayEditable: boolean;
    public emailAddressEditable: boolean = false;
    public submissionStatusEditable: boolean;
}